import { Controller } from "stimulus"

export default class extends Controller {
	// Can't use this api yet because it's stimulus 2.0
	// The cool thing about it is it carries with it it's own "mutation observer", so it's easy to do stuff when it changes.
	// See: https://stimulus.hotwire.dev/handbook/managing-state#what’s-with-that-static-values-line%3F
	//static values = { src: String }

	connect() {
    this.element.classList.add('loading'); // I'm actually not sure what removes this class, but it does get removed! X-D

		// This can be removed once we update to Stimulus 2.0 and static values (see top) can be used instead (will populate the same var automagically)
		this.srcValue = this.element.getAttribute("data-display-document-src-value");

    this.iframe = document.createElement('iframe');
    this.iframe.classList.add('document-preview');
    this.iframe.setAttribute('id', 'document-frame');
    this.iframe.setAttribute('src', this.srcValue);
    this.iframe.setAttribute('seamless', 'true');
    this.iframe.setAttribute('scrolling', 'no');
    this.iframe.setAttribute('width', '100%');

    // We set the iframe's onload function to our resize function so we place the tooltips correctly
    // from the start. We need to bind 'this' to it, since it's a callback that will run outside the current scope.
    this.iframe.onload = this.resize.bind(this);

    // If we go back to document show in browser history the iframe
    // could be loaded so we empty the document wrapper before appending.
    this.element.getChildren().destroy();

    this.element.appendChild(this.iframe);
	}

	resize() {
		this.iframe.height = this.iframe.contentDocument.body.parentNode.getBoundingClientRect().height;

		this.showToolTipSign('.document-frame-ad-tooltip', '.ad', false)
  	this.showToolTipSign('.document-frame-newtoautomode-tooltip', '.new_payment_details')
	}

	showToolTipSign(signSelector, targetSelector, above = true) {
	  var tooltipEl = this.element.parentNode.querySelector(signSelector);
	  var targetEl = this.iframe.contentDocument.body.querySelector(targetSelector);

	  // Only show / position the tooltips if both the tooltip and the target are there
	  // This is in fact what hides the ad-tooltip on invoices where it shouldn't be shown
	  if(!tooltipEl || !targetEl) { return }

	  tooltipEl.style.display = 'block';
	  var toolTipStyles = this.getStyles(tooltipEl);
	  var targetStyles = this.getStyles(targetEl);

	  if(above) { // Above
	  	tooltipEl.style.top = `calc(${targetStyles.top} - ${targetStyles.height} - ${targetStyles.marginTop} - ${toolTipStyles.height})`;
	  } else { // Below
	  	tooltipEl.style.top = `calc(${targetStyles.top} + ${targetStyles.height} + ${targetStyles.marginTop})`;
	  }

	  tooltipEl.style.left = `calc(${targetStyles.left})`;
	}

	// Returns an object with width, height, marginTop, marginBottom, marginLeft, marginRight
	getStyles(el) {
	  var bRect = el.getBoundingClientRect();
	  var style = window.getComputedStyle(el);

	  return {
	    height: parseInt(bRect.height) + 'px',
	    width: parseInt(bRect.width) + 'px',
	    top: parseInt(bRect.top) + 'px',
	    bottom: parseInt(bRect.bottom) + 'px',
	    left: parseInt(bRect.left) + 'px',
	    right: parseInt(bRect.right) + 'px',
	    marginTop: parseInt(style.marginTop) + 'px',
	    marginBottom: parseInt(style.marginBottom) + 'px',
	    marginLeft: parseInt(style.marginLeft) + 'px',
	    marginRight: parseInt(style.marginRight) + 'px',
	    paddingTop: parseInt(style.paddingTop) + 'px',
	    paddingBottom: parseInt(style.paddingBottom) + 'px',
	    paddingLeft: parseInt(style.paddingLeft) + 'px',
	    paddingRight: parseInt(style.paddingRight) + 'px'
	  }
	}
}